import(/* webpackMode: "eager" */ "/codebuild/output/src1406245528/src/colmena-2024-v2/src/app/not-found.tsx");
